const get = require('lodash/get')

module.exports = function () {
  return {
    $get: ['$rootScope', '$location', '$phoneModal', '$loading', '$translate', '$ionicPopup', 'LocalStorage', '$$size', '$window', '$sce', '$$html', '$$misc',
      function ($rootScope, $location, $phoneModal, $loading, $translate, $ionicPopup, LocalStorage, $$size, $window, $sce, $$html, $$misc) {
      /* --------------------attachment--------------------- */
        const typeMapMime = {
          'text/css': 'txt',
          'text/plain': 'txt',
          'text/javascript': 'txt',
          'text/html': 'ie',
          'text/xml': 'xml',
          'text/csv': 'csv',
          'text/x-vcard': 'vcf',
          'application/hta': 'ie',
          'application/xml': 'xml',
          'application/pdf': 'pdf',
          'application/msaccess': 'access',
          'application/msword': 'word',
          'application/vnd.ms-word': 'word',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word',
          'application/x-msexcel': 'excel',
          'application/vnd.ms-excel': 'excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
          'application/x-mspowerpoint': 'ppt',
          'application/vnd.ms-powerpoint': 'ppt',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
          'application/x-sh': 'system',
          'application/x-csh': 'system',
          'application/zip': 'archive',
          'application/x-tar': 'archive',
          'application/x-gzip': 'archive',
          'application/x-compress': 'archive',
          'application/java-archive': 'archive',
          'application/x-zip-compressed': 'archive'
        }

        const attachment = {
          /**
           * 判断某文件名是否支持预览
           * 判断某文件名是否支持预览
           * @param  {String}  filename
           * @return {Boolean}
           */
          isSupportPreview: function (filename) {
            const type = this.getExtName(filename)
            return $rootScope.settings.preview && ($rootScope.settings.previewType.indexOf(type) > -1 || false)
          },

          /**
           * 根据文件类型获取图标ID
           * @param  {String} filename 文件名称
           * @return {String}
           */
          getIconType: function (filename) {
            const type = this.getExtName(filename)
            const iconMap = {
              'xls': '2',
              'xlsx': '2',
              'csv': '2',
              'doc': '3',
              'docx': '3',
              'ppt': '4',
              'pptx': '4',
              '7z': '5',
              'rar': '6',
              'cab': '6',
              'jar': '6',
              'arj': '6',
              'tar': '6',
              'gz': '6',
              'tgz': '6',
              'zip': '7',
              'iso': '8',
              'img': '8',
              'nrg': '8',
              'mdf': '8',
              'mds': '8',
              'eml': '9',
              'htm': '10',
              'html': '10',
              'shtml': '10',
              'xhtml': '10',
              'mht': '10',
              'asp': '10',
              'aspx': '10',
              'js': '11',
              'css': '12',
              'ini': '12',
              'inf': '12',
              'xml': '12',
              'hlp': '13',
              'chm': '13',
              'exe': '14',
              'app': '14',
              'com': '14',
              'bat': '15',
              'cmd': '15',
              'ttf': '16',
              'fon': '16',
              'pdf': '17',
              'psd': '18',
              'pdd': '18',
              'ps': '18',
              'ai': '19',
              'eps': '19',
              'fla': '20',
              'swf': '21',
              'flv': '21',
              'txt': '22',
              'java': '22',
              'jsp': '22',
              'c': '22',
              'cpp': '22',
              'h': '22',
              'hpp': '22',
              'py': '22',
              'cs': '22',
              'sh': '22',
              'rtf': '23',
              'reg': '24',
              'ra': '25',
              'ram': '25',
              'rpm': '25',
              'rmx': '25',
              'rm': '25',
              'rmvb': '25',
              'wm': '26',
              'wma': '26',
              'wmv': '26',
              'asf': '26',
              'wmp': '26',
              'mov': '27',
              'qt': '27',
              '3gp': '27',
              '3gpp': '27',
              'amr': '27',
              'avi': '28',
              'mkv': '28',
              'mp4': '28',
              'mpg': '28',
              'mpeg': '28',
              'vob': '28',
              'dat': '28',
              'ts': '28',
              'tp': '28',
              'm2ts': '28',
              'evo': '28',
              'pmp': '28',
              'vp6': '28',
              'ivf': '28',
              'dsm': '28',
              'dsv': '28',
              'dsa': '28',
              'dss': '28',
              'fli': '28',
              'flc': '28',
              'flic': '28',
              'roq': '28',
              'mpa': '29',
              'm1a': '29',
              'm2a': '29',
              'mp2': '29',
              'mp3': '29',
              'ac3': '29',
              'dts': '29',
              'ddp': '29',
              'flac': '29',
              'ape': '29',
              'mac': '29',
              'apl': '29',
              'shn': '29',
              'tta': '29',
              'wv': '29',
              'cda': '29',
              'wav': '29',
              'aac': '29',
              'm4a': '29',
              'mka': '29',
              'ogg': '29',
              'mpc': '29',
              'mp+': '29',
              'mpp': '29',
              'au': '29',
              'aif': '29',
              'aifc': '29',
              'aiff': '29',
              'mid': '29',
              'midi': '29',
              'rmi': '29',
              'todo': '30',
              'jpg': '31',
              'jpeg': '31',
              'gif': '32',
              'png': '33',
              'bmp': '34',
              'dib': '34',
              'rle': '34',
              'tif': '35',
              'tiff': '35',
              'xif': '35',
              'emf': '36',
              'wmf': '37',
              'ico': '38',
              'icl': '38',
              'cur': '38',
              'ani': '38',
              'raw': '39',
              'mos': '39',
              'fff': '39',
              '032': '39',
              'bay': '39',
              'cdr': '40',
              'csl': '40',
              'cmx': '40',
              'wpg': '40',
              'dll': '41',
              'ocx': '41',
              'chk': '41',
              'manifest': '41',
              'torrent': '42',
              'wps': '43',
              'wpt': '43',
              'dps': '44',
              'et': '45',
              'msi': '46'
            }
            return iconMap[type]
          },

          getMimeType: function (filename) {
            const type = this.getExtName(filename)
            const MimeMap = {
              'bmp': 'image/bmp',
              'gif': 'image/gif',
              'ifm': 'image/gif',
              'pnz': 'image/png',
              'x-png': 'image/png',
              'jpe': 'image/jpeg',
              'jpeg': 'image/jpeg',
              'jpg': 'image/jpeg',
              'png': 'image/jpeg',
              'jpz': 'image/jpeg',
              'svg': 'image/svg+xml',
              'ico': 'image/x-icon',
              'xpm': 'image/xpm',
              'xbm': 'image/xbm',
              'xif': 'image/vnd.xiff',
              'css': 'text/css',
              'xml': 'text/xml',
              'xsit': 'text/xml',
              'xsl': 'text/xml',
              'ie': 'text/html',
              'htm': 'text/html',
              'html': 'text/html',
              'shtml': 'text/html',
              'stm': 'text/html',
              'hts': 'text/html',
              'dhtml': 'text/html',
              'log': 'text/plain',
              'txt': 'text/plain',
              'text': 'text/plain',
              'java': 'text/plain',
              'list': 'text/plain',
              'lst:': 'text/plain',
              'asc': 'text/plain',
              'bas': 'text/plain',
              'c': 'text/plain',
              'cpp': 'text/plain',
              'h': 'text/plain',
              'prop': 'text/plain',
              'rc': 'text/plain',
              'asm': 'text/x-asm',
              'asp': 'text/asp',
              'mpg4': 'video/mp4',
              'wav': 'audio/x-wav',
              'mp3': 'audio/mpeg',
              'mpga': 'audio/mpeg',
              'mpeg': 'video/mpeg',
              'mpv2': 'video/mpeg',
              'mp2': 'video/mpeg',
              'mpa': 'video/mpeg',
              'mpe': 'video/mpeg',
              'mpg': 'video/mpeg',
              'avi': 'video/x-msvideo',
              'mov': 'video/x-msvideo',
              'mp4': 'video/x-msvideo',
              'swf': 'application/x-shockwave-flash',
              'js': 'application/x-javascript',
              'json': 'application/json',
              'pdf': 'application/pdf',
              'apk': 'application/vnd.android.package-archive',
              'nar': 'application/zip',
              '7z': 'application/zip',
              'zip': 'application/zip',
              'rar': 'application/zip',
              'xl': 'application/excel',
              'xld': 'application/x-excel',
              'xlk': 'application/x-excel',
              'xlw': 'application/vnd.ms-excel',
              'xlm': 'application/vnd.ms-excel',
              'xlb': 'application/vnd.ms-excel',
              'xlc': 'application/vnd.ms-excel',
              'xls': 'application/vnd.ms-excel',
              'xlt': 'application/vnd.ms-excel',
              'xla': 'application/vnd.ms-excel',
              'xlv': 'application/vnd.ms-excel',
              'xll': 'application/vnd.ms-excel',
              'doc': 'application/msword',
              'dot': 'application/msword',
              'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'dotx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
              'docm': 'application/vnd.ms-word.document.macroEnabled.12',
              'dotm': 'application/vnd.ms-word.template.macroEnabled.12',
              'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'xltx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
              'xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
              'xltm': 'application/vnd.ms-excel.template.macroEnabled.12',
              'xlam': 'application/vnd.ms-excel.addin.macroEnabled.12',
              'xlsb': 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
              'ppt': 'application/vnd.ms-powerpoint',
              'pot': 'application/vnd.ms-powerpoint',
              'pps': 'application/vnd.ms-powerpoint',
              'ppa': 'application/vnd.ms-powerpoint',
              'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
              'potx': 'application/vnd.openxmlformats-officedocument.presentationml.template',
              'ppsx': 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
              'ppam': 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
              'pptm': 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
              'potm': 'application/vnd.ms-powerpoint.template.macroEnabled.12',
              'ppsm': 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
              'z  ': 'application/x-compress',
              '3dm': 'x-world/x-3dmf',
              '3dmf': 'x-world/x-3dmf',
              'tgz': 'application/x-compressed',
              'rtf': 'application/rtf',
              'rtx': 'application/rtf',
              'pkg': 'application/x-newton-compatible-pkg',
              'ps': 'application/postscript',
              'py': 'text/x-script.phyton',
              'rmi': 'audio/mid',
              'rpm': 'audio/x-pn-realaudio-plugin',
              'shar': 'application/x-shar',
              'sh': ' text/x-script.sh',
              'vmd': 'application/vocaltec-media-desc',
              'vmf': 'application/vocaltec-media-file',
              'wmf': 'windows/metafile',
              'wps': 'application/vnd.ms-works',
              'wcm': 'application/vnd.ms-works',
              'wdb': 'application/vnd.ms-works',
              'wks': 'application/vnd.ms-works',
              'jar': 'application/java-archive',
              'so': 'application/octet-stream',
              'conf': 'application/octet-stream',
              'accdb': 'application/octet-stream',
              'gradle': 'application/octet-stream',
              'license': 'application/octet-stream',
              'exe': 'application/octet-stream',
              'ani': 'application/octet-stream',
              'avb': 'application/octet-stream',
              'bin ': 'application/octet-stream',
              'bpk': 'application/octet-stream',
              'class': 'application/octet-stream',
              'cur': 'application/octet-stream',
              'dmg': 'application/octet-stream',
              'dms': 'application/octet-stream',
              'lha': 'application/octet-stream',
              'lzh': 'application/octet-stream',
              'pro': 'application/octet-stream',
              'psd': 'application/octet-stream',
              'tad': 'application/octet-stream',
              'ttf': 'application/octet-stream',
              'tar': 'application/x-tar',
              'taz': 'application/x-tar',

              '323': 'text/h323',
              '3gp': 'video/3gpp',
              'aab': 'application/x-authoware-bin',
              'aam': 'application/x-authoware-map',
              'aas': 'application/x-authoware-seg',
              'acx': 'application/internet-property-stream',
              'ai': 'application/postscript',
              'aif': 'audio/x-aiff',
              'aifc': 'audio/x-aiff',
              'aiff': 'audio/x-aiff',
              'als': 'audio/X-Alpha5',
              'amc': 'application/x-mpeg',
              'asf': 'video/x-ms-asf',
              'asd': 'application/astound',
              'asn': 'application/astound',
              'asr': 'video/x-ms-asf',
              'asx': 'video/x-ms-asf',
              'au': 'audio/basic',
              'snd': 'audio/basic',
              'awb': 'audio/amr-wb',
              'axs': 'application/olescript',
              'bcpio': 'application/x-bcpio',
              'bld': 'application/bld',
              'bld2': 'application/bld2',
              'bz2': 'application/x-bzip2',
              'cal': 'image/x-cals',
              'cat': 'application/vnd.ms-pkiseccat',
              'ccn': 'application/x-cnc',
              'cco': 'application/x-cocoa',
              'cdf': 'application/x-cdf',
              'cer': 'application/x-x509-ca-cert',
              'cgi': 'magnus-internal/cgi',
              'chat': 'application/x-chat',

              'clp': 'application/x-msclip',
              'cmx': 'image/x-cmx',
              'co': 'application/x-cult3d-object',
              'cod': 'image/cis-cod',
              'cpio': 'application/x-cpio',
              'cpt': 'application/mac-compactpro',
              'crd': 'application/x-mscardfile',
              'crl': 'application/pkix-crl',
              'crt': 'application/x-x509-ca-cert',
              'csh': 'application/x-csh',
              'csm': 'chemical/x-csml',
              'csml': 'chemical/x-csml',
              'dcm': 'x-lml/x-evm',
              'dcr': 'application/x-director',
              'dir': 'application/x-director',
              'dcx': 'image/x-dcx',
              'der': 'application/x-x509-ca-cert',
              'dll': 'application/x-msdownload',

              'dvi': 'application/x-dvi',
              'dwf': 'drawing/x-dwf',
              'dwg': 'application/x-autocad',
              'dxf': 'application/x-autocad',
              'dxr': 'application/x-director',
              'ebk': 'application/x-expandedbook',
              'emb': 'chemical/x-embl-dl-nucleotide',
              'embl': 'chemical/x-embl-dl-nucleotide',
              'eps': 'application/postscript',
              'epub': 'application/epub+zip',
              'eri': 'image/x-eri',
              'es': 'audio/echospeech',
              'esl': 'audio/echospeech',
              'etc': 'application/x-earthtime',
              'etx': 'text/x-setext',
              'evm': 'x-lml/x-evm',
              'evy': 'application/envoy',
              'fh4': 'image/x-freehand',
              'fh5': 'image/x-freehand',
              'fhc': 'image/x-freehand',
              'fif': 'application/fractals',
              'flr': 'x-world/x-vrml',
              'flv': 'flv-application/octet-stream',
              'fm': 'application/x-maker',
              'fpx': 'image/x-fpx',
              'fvi': 'video/isivideo',
              'gau': 'chemical/x-gaussian-input',
              'gca': 'application/x-gca-compressed',
              'gdb': 'x-lml/x-gdb',
              'gps': 'application/x-gps',
              'gtar': 'application/x-gtar',
              'gz': 'application/x-gzip',
              'x-gzip': 'application/x-gzip',
              'hdf': 'application/x-hdf',
              'hdm': 'text/x-hdml',
              'hdml': 'text/x-hdml',
              'hlp': 'application/winhlp',
              'hqx': 'application/mac-binhex40',
              'hta': 'application/hta',
              'htc': 'text/x-component',
              'htt': 'text/webviewhtml',
              'ice': 'x-conference/x-cooltalk',
              'ief': 'image/ief',
              'ifs': 'image/ifs',
              'iii': 'application/x-iphone',
              'imy': 'audio/melody',
              'ins': 'application/x-internet-signup',
              'ips': 'application/x-ipscript',
              'ipx': 'application/x-ipix',
              'isp': 'application/x-internet-signup',
              'it': 'audio/x-mod',
              'itz': 'audio/x-mod',
              'ivr': 'i-world/i-vrml',
              'j2k': 'image/j2k',
              'jad': 'text/vnd.sun.j2me.app-descriptor',
              'jam': 'application/x-jam',
              'jfif': 'image/pipeg',
              'jnlp': 'application/x-java-jnlp-file',
              'jwc': 'application/jwc',
              'kjx': 'application/x-kjx',
              'lak': 'x-lml/x-lak',
              'latex': 'application/x-latex',
              'lcc': 'application/fastman',
              'lcl': 'application/x-digitalloca',
              'lcr': 'application/x-digitalloca',
              'lgh': 'application/lgh',
              'lml': 'x-lml/x-lml',
              'lmlpack': 'x-lml/x-lmlpack',
              'lsf': 'video/x-la-asf',
              'lsx': 'video/x-la-asf',
              'm13': 'application/x-msmediaview',
              'm14': 'application/x-msmediaview',
              'm15': 'audio/x-mod',
              'm3u': 'audio/x-mpegurl',
              'm3url': 'audio/x-mpegurl',
              'm4a': 'audio/mp4a-latm',
              'm4b': 'audio/mp4a-latm',
              'm4p': 'audio/mp4a-latm',
              'm4u': 'video/vnd.mpegurl',
              'm4v': 'video/x-m4v',
              'ma1': 'audio/ma1',
              'ma2': 'audio/ma2',
              'ma3': 'audio/ma3',
              'ma5': 'audio/ma5',
              'man': 'application/x-troff-man',
              'map': 'magnus-internal/imagemap',
              'mbd': 'application/mbedlet',
              'mct': 'application/x-mascot',
              'mdb': 'application/x-msaccess',
              'mdz': 'audio/x-mod',
              'me': 'application/x-troff-me',
              'mel': 'text/x-vmel',
              'mht': 'message/rfc822',
              'mhtml': 'message/rfc822',
              'mi': 'application/x-mif',
              'mif': 'application/x-mif',
              'mid': 'audio/mid',
              'midi': 'audio/midi',
              'mil': 'image/x-cals',
              'mio': 'audio/x-mio',
              'mmf': 'application/x-skt-lbs',
              'mng': 'video/x-mng',
              'mny': 'application/x-msmoney',
              'moc': 'application/x-mocha',
              'mocha': 'application/x-mocha',
              'mod': 'audio/x-mod',
              'mof': 'application/x-yumekara',
              'mol': 'chemical/x-mdl-molfile',
              'mop': 'chemical/x-mopac-input',
              'movie': 'video/x-sgi-movie',
              'mpc': 'application/vnd.mpohun.certificate',
              'mpn': 'application/vnd.mophun.application',
              'mpp': 'application/vnd.ms-project',
              'mps': 'application/x-mapserver',
              'mrl': 'text/x-mrml',
              'mrm': 'application/x-mrm',
              'ms': 'application/x-troff-ms',
              'msg': 'application/vnd.ms-outlook',
              'mvb': 'application/x-msmediaview',
              'mts': 'application/metastream',
              'mtx': 'application/metastream',
              'mtz': 'application/metastream',
              'mzv': 'application/metastream',
              'nbmp': 'image/nbmp',
              'nc': 'application/x-netcdf',
              'ndb': 'x-lml/x-ndb',
              'ndwn': 'application/ndwn',
              'nif': 'application/x-nif',
              'nmz': 'application/x-scream',
              'nokia-op-logo': 'image/vnd.nok-oplogo-color',
              'npx': 'application/x-netfpx',
              'nsnd': 'audio/nsnd',
              'nva': 'application/x-neva1',
              'nws': 'message/rfc822',
              'oda': 'application/oda',
              'ogg': 'audio/ogg',
              'oom': 'application/x-AtlasMate-Plugin',
              'p10': 'application/pkcs10',
              'p12': 'application/x-pkcs12',
              'p7b': 'application/x-pkcs7-certificates',
              'p7c': 'application/x-pkcs7-mime',
              'p7m': 'application/x-pkcs7-mime',
              'p7r': 'application/x-pkcs7-certreqresp',
              'p7s': 'application/x-pkcs7-signature',
              'pac': 'audio/x-pac',
              'pae': 'audio/x-epac',
              'pan': 'application/x-pan',
              'pbm': 'image/x-portable-bitmap',
              'pcx': 'image/x-pcx',
              'pda': 'image/x-pda',
              'pdb': 'chemical/x-pdb',
              'pfr': 'application/font-tdpfr',
              'pfx': 'application/x-pkcs12',
              'pgm': 'image/x-portable-graymap',
              'pict': 'image/x-pict',
              'pko': 'application/ynd.ms-pkipko',
              'pm': 'application/x-perl',
              'pmd': 'application/x-pmd',
              'pma': 'application/x-perfmon',
              'pmc': 'application/x-perfmon',
              'pml': 'application/x-perfmon',
              'pmr': 'application/x-perfmon',
              'pmw': 'application/x-perfmon',
              'pnm': 'image/x-portable-anymap',
              'pot,': 'application/vnd.ms-powerpoint',
              'ppm': 'image/x-portable-pixmap',
              'pqf': 'application/x-cprplayer',
              'pqi': 'application/cprplayer',
              'prc': 'application/x-prc',
              'prf': 'application/pics-rules',
              'proxy': 'application/x-ns-proxy-autoconfig',
              'ptlk': 'application/listenup',
              'pub': 'application/x-mspublisher',
              'pvx': 'video/x-pv-pvx',
              'qcp': 'audio/vnd.qcelp',
              'qt': 'video/quicktime',
              'qti': 'image/x-quicktime',
              'qtif': 'image/x-quicktime',
              'r3t': 'text/vnd.rn-realtext3d',
              'rmf': 'audio/x-rmf',
              'ra': 'audio/x-pn-realaudio',
              'ram': 'audio/x-pn-realaudio',
              'ras': 'image/x-cmu-raster',
              'rdf': 'application/rdf+xml',
              'rf': 'image/vnd.rn-realflash',
              'rgb': 'image/x-rgb',
              'rlf': 'application/x-richlink',
              'rm': 'audio/x-pn-realaudio',
              'rmm': 'audio/x-pn-realaudio',
              'rmvb': 'audio/x-pn-realaudio',
              'rnx': 'application/vnd.rn-realplayer',
              'roff': 'application/x-troff',
              'rp': 'image/vnd.rn-realpix',
              'rt': 'text/vnd.rn-realtext',
              'rte': 'x-lml/x-gps',
              'rtg': 'application/metastream',
              'rv': 'video/vnd.rn-realvideo',
              'rwc': 'application/x-rogerwilco',
              's3m': 'audio/x-mod',
              's3z': 'audio/x-mod',
              'sca': 'application/x-supercard',
              'scd': 'application/x-msschedule',
              'sct': 'text/scriptlet',
              'sdf': 'application/e-score',
              'sea': 'application/x-stuffit',
              'setpay': 'application/set-payment-initiation',
              'setreg': 'application/set-registration-initiation',
              'sgm': 'text/x-sgml',
              'sgml': 'text/x-sgml',
              'shw': 'application/presentations',
              'si6': 'image/si6',
              'si7': 'image/vnd.stiwap.sis',
              'si9': 'image/vnd.lgtwap.sis',
              'sis': 'application/vnd.symbian.install',
              'sit': 'application/x-stuffit',
              'skd': 'application/x-Koan',
              'skm': 'application/x-Koan',
              'skp': 'application/x-Koan',
              'skt': 'application/x-Koan',
              'slc': 'application/x-salsa',
              'smd': 'audio/x-smd',
              'smz': 'audio/x-smd',
              'smi': 'application/smil',
              'smil': 'application/smil',
              'smp': 'application/studiom',
              'spc': 'application/x-pkcs7-certificates',
              'spl': 'application/futuresplash',
              'spr': 'application/x-sprite',
              'sprite': 'application/x-sprite',
              'sdp': 'application/sdp',
              'spt': 'application/x-spt',
              'src': 'application/x-wais-source',
              'sst': 'application/vnd.ms-pkicertstore',
              'stk': 'application/hyperstudio',
              'stl': 'application/vnd.ms-pkistl',
              'sv4cpio': 'application/x-sv4cpio',
              'sv4crc': 'application/x-sv4crc',
              'svf': 'image/vnd',
              'svh': 'image/svh',
              'svr': 'x-world/x-svr',
              'swfl': 'application/x-shockwave-flash',
              't': 'application/x-troff',

              'talk': 'text/x-speech',
              'tbp': 'application/x-timbuktu',
              'tbt': 'application/x-timbuktu',
              'tcl': 'application/x-tcl',
              'tex': 'application/x-tex',
              'texi': 'application/x-texinfo',
              'texinfo': 'application/x-texinfo',
              'thm': 'application/vnd.eri.thm',
              'tif': 'image/tiff',
              'tiff': 'image/tiff',
              'tki': 'application/x-tkined',
              'tkined': 'application/x-tkined',
              'toc': 'application/toc',
              'toy': 'image/toy',
              'tr': 'application/x-troff',
              'trk': 'x-lml/x-gps',
              'trm': 'application/x-msterminal',
              'tsi': 'audio/tsplayer',
              'tsp': 'application/dsptype',
              'tsv': 'text/tab-separated-values',
              'ttz': 'application/t-time',
              'uls': 'text/iuls',
              'ult': 'audio/x-mod',
              'ustar': 'application/x-ustar',
              'uu': 'application/x-uuencode',
              'uue': 'application/x-uuencode',
              'vcd': 'application/x-cdlink',
              'vcf': 'text/x-vcard',
              'vdo': 'video/vdo',
              'vib': 'audio/vib',
              'viv': 'video/vivo',
              'vivo': 'video/vivo',
              'vmi': 'application/x-dreamcast-vms-info',
              'vms': 'application/x-dreamcast-vms',
              'vox': 'audio/voxware',
              'vqe': 'audio/x-twinvq-plugin',
              'vqf': 'audio/x-twinvq',
              'vql': 'audio/x-twinvq',
              'vre': 'x-world/x-vream',
              'vrw': 'x-world/x-vream',
              'vrml': 'x-world/x-vrml',
              'vrt': 'x-world/x-vrt',
              'vts': 'workbook/formulaone',
              'wax': 'audio/x-ms-wax',
              'wbmp': 'image/vnd.wap.wbmp',
              'web': 'application/vnd.xara',
              'wi': 'image/wavelet',
              'wis': 'application/x-InstallShield',
              'wm': 'video/x-ms-wm',
              'wmx': 'video/x-ms-wmx',
              'wv': 'video/wavelet',
              'wvx': 'video/x-ms-wvx',
              'wmv': 'audio/x-ms-wmv',
              'wma': 'audio/x-ms-wma',
              'wmd': 'application/x-ms-wmd',
              'wml': 'text/vnd.wap.wml',
              'wmlc': 'application/vnd.wap.wmlc',
              'wmls': 'text/vnd.wap.wmlscript',
              'wmlsc': 'application/vnd.wap.wmlscriptc',
              'wmlscript': 'text/vnd.wap.wmlscript',
              'wmz': 'application/x-ms-wmz',
              'wpng': 'image/x-up-wpng',
              'wpt': 'x-lml/x-gps',
              'wri': 'application/x-mswrite',
              'wrl': 'x-world/x-vrml',
              'wrz': 'x-world/x-vrml',
              'xaf': 'x-world/x-vrml',
              'xof': 'x-world/x-vrml',
              'ws': 'text/vnd.wap.wmlscript',
              'wsc': 'application/vnd.wap.wmlscriptc',
              'wxl': 'application/x-wxl',
              'xar': 'application/vnd.xara',
              'xdm': 'application/x-xdma',
              'xdma': 'application/x-xdma',
              'xdw': 'application/vnd.fujixerox.docuworks',
              'xht': 'application/xhtml+xml',
              'xhtm': 'application/xhtml+xml',
              'xhtml': 'application/xhtml+xml',
              'xm': 'audio/x-mod',
              'xmz': 'audio/x-mod',
              'xpi': 'application/x-xpinstall',
              'xul': 'text/xul',
              'xwd': 'image/x-xwindowdump',
              'xyz': 'chemical/x-pdb',
              'yz1': 'application/x-yz1',
              'z': 'application/x-compress',
              'zac': 'application/x-zaurus-zac'
            }
            if (MimeMap[type]) {
              return MimeMap[type]
            } else {
              return 'unknown'
            }
          },
          startsWith: function (s, s0) {
            if (s) return (s.substring(0, s0.length) == s0)
          },

          endsWith: function (s, s0) {
            if (s) return (s.substring(s.length - s0.length) == s0)
          },

          getIconClass: function (fileName, mimeType) {
            let x = typeMapMime[mimeType]
            if (x) {
            } else if (this.startsWith(mimeType, 'image/')) {
              x = this.getExtName(fileName)
            } else if (this.startsWith(mimeType, 'audio/')) {
              x = 'media'
            } else if (this.startsWith(mimeType, 'video/')) {
              x = 'media'
            } else {
              x = this.getExtName(fileName)
            }
            return x
          },

          //  论客用到
          getSignType: function (fileName, mimeType) {
            // 0 是一般文件  1 是帖子  2 是代码段  3是文档  （pdf doc xls txt） 4是图片  5是语音 6暂时没用到   7是扩展的也是没用到 8是多媒体
            const typeMap = {
              'apk': '0',
              'zip': '0',
              'rar': '0',
              '7z': '0',
              'system': '0',
              'archive': '0',
              'ie': '0',
              'xml': '3',
              'csv': '3',
              'vcf': '3',
              'pdf': '3',
              'htm': '3',
              'html': '3',
              'js': '3',
              'css': '3',
              'txt': '3',
              'access': '3',
              'word': '3',
              'excel': '3',
              'ppt': '3',
              'pps': '3',
              'pot': '3',
              'xlw': '3',
              'xlt': '3',
              'xls': '3',
              'xlm': '3',
              'xlc': '3',
              'xla': '3',
              'doc': '3',
              'dot': '3',
              'docx': '3',
              'bmp': '4',
              'gif': '4',
              'jpe': '4',
              'jpeg': '4',
              'jpg': '4',
              'png': '4',
              'svg': '4',
              'ico': '4',
              'avi': '8',
              'mov': '8',
              'mp4': '8',
              'mp3': '8',
              'wav': '8',
              'swf': '8'
            }
            const type = this.getIconClass(fileName, mimeType)
            return typeMap[type] || '0'
          },

          // 获取文件后缀名
          getExtName: function (s) {
            s = s || ''
            const i = s.lastIndexOf('.')
            let extName
            if (i != -1) {
              extName = s.substring(i + 1).toLowerCase()
            } else {
              extName = ''
            }
            return extName
          },

          // 判断某文件是否为压缩文件
          isCompressedFile: function (filename) {
            const type = this.getExtName(filename)
            return /^(?:(?:r|t|j)ar|g?zip|(?:7|g)z|cab|arj|lzh|ace|uue|bz2|iso|mpq)$/.test(type)
          },

          getPreviewUrl: function (options) {
            const protocol = $location.protocol()
            const host = $location.host()
            const port = $location.port()
            const coremailUrl = LocalStorage.getItem('coremailurl')
            let url
            // 存在coremailUrl则优先使用
            if (typeof coremailUrl === 'string' && coremailUrl.indexOf('http') === 0) url = coremailUrl + '/common/preview/preview.jsp'
            else url = protocol + '://' + host + (port === 80 ? '' : (':' + port)) + '/coremail/common/preview/preview.jsp'
            // 预览附件类型包括：
            // 1. 写信附件
            // 2. 网盘(个人/企业）附件
            // 3. 读信附件
            // 4. 来往附件
            const attachId = options.attachId
            const composeId = options.composeId
            const fileId = options.fileId
            const uid = options.uid
            const mid = options.mid
            const part = options.part
            // 默认预览页面使用内嵌模式
            url += '?embedded=false'
            if (attachId && composeId) {
              url += '&attachId=' + attachId + '&composeId=' + composeId
            } else if (fileId) {
              url += '&fileId=' + fileId + (uid ? '&uid=' + uid : '')
            } else if (mid) {
              url += '&mid=' + mid + (part ? '&part=' + part : '')
            } else if (attachId && part) {
              url += `&part=${part}&mid=${mid}`
            }
            return url
          },
          // 获取指定文件类型的预览限制大小
          getPreviewLimit(type) {
            const account = LocalStorage.getItem('account') || {}
            const currentUser = account[account.currentUserId] || {}
            let previewSizeLimit = get(currentUser, '$ajc.user.previewSizeLimit')
            if (!previewSizeLimit) return null

            previewSizeLimit = previewSizeLimit.replace(/；/ig, ';').replace(/：/ig, ':').replace(/，/ig, ',')
            const fileTypePreviewLimit = {}
            previewSizeLimit.split(';').forEach(function(item) {
              const temp = item.trim().split(':')
              const fileTypes = temp[0]
              const typePreviewLimit = temp[1] * 1024
              fileTypes.split(',').forEach(function(type) {
                fileTypePreviewLimit[type] = typePreviewLimit
              })
            })
            return fileTypePreviewLimit[type] || null
          },
          // 判断是否支持指定大小,类型的文件的预览
          isSizeTypePreviewSupported(params) {
            const previewLimit = this.getPreviewLimit(params.type)
            if (previewLimit) {
              return previewLimit > params.size
            } else {
              return true
            }
          }
        }
        return attachment
      }]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/attachment.js